import Link from 'next/link';
import { useAuth } from '../../components/context/Info'; // ajuste o path conforme seu projeto
import { getAccessibleTextColor } from '../../utils/FunctionsGlobals';
import styles from './PopUpComponent.module.css';

const PopUpComponent: React.FC<{ site?: any }> = ({ site }) => {
    // Pegue o politic do context
    const { politic, setPolitic } = useAuth();

    // Só mostra o popup se o consentimento ainda não foi dado
    if (politic == 'accepted' || politic == 'rejected' || politic == null) {
        return null;
    }
    const acceptButtonBackground = site?.cor2 || '#1e1e1e';
    const acceptButtonTextColor = getAccessibleTextColor(acceptButtonBackground);

    return (
        <div className={styles.background_container}>
            <div className={styles.container}>
                <div className={styles.container_descriptions}>
                    <label>
                        Usamos cookies para personalizar conteúdos e melhorar a
                        sua experiência no nosso site. Ao continuar navegando,
                        você concorda com o nosso
                    </label>
                    <div className={styles.container_terms}>
                        <Link prefetch={false} href="/termos">
                            <div className={styles.terms}>
                                Termos de Uso
                            </div>
                        </Link>
                        <Link prefetch={false} href="/politica">
                            <div className={styles.terms}>
                                Política de Privacidade
                            </div>
                        </Link>
                    </div>
                </div>
                <div className={styles.buttons}>
                    <div
                        className={styles.button}
                        onClick={() => setPolitic('accepted')}
                        style={{ color: acceptButtonTextColor, background: acceptButtonBackground }}
                    >
                        Concordar
                    </div>
                    <div
                        className={styles.button_r}
                        onClick={() => setPolitic('rejected')}
                    >
                        Rejeitar
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopUpComponent;
